<div class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

    <!-- Vertical Navigation Layout -->
    <ng-container *ngIf="layout === 'vertical'">

        <ng-container *ngFor="let item of navigation">
            <fuse-nav-vertical-group *ngIf="item.type=='group'" [item]="item" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}"></fuse-nav-vertical-group>
            <fuse-nav-vertical-collapsable *ngIf="item.type=='collapsable'" [item]="item" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}"></fuse-nav-vertical-collapsable>
            <fuse-nav-vertical-item *ngIf="item.type=='item'" [item]="item" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}"></fuse-nav-vertical-item>
        </ng-container>

    </ng-container>
    <!-- / Vertical Navigation Layout -->

    <!-- Horizontal Navigation Layout -->
    <ng-container *ngIf="layout === 'horizontal'">

        <ng-container *ngFor="let item of navigation">
            <fuse-nav-horizontal-collapsable *ngIf="item.type=='group'" [item]="item"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-collapsable *ngIf="item.type=='collapsable'" [item]="item"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></fuse-nav-horizontal-item>
        </ng-container>

    </ng-container>
    <!-- / Horizontal Navigation Layout -->
    <br>
    <!-- <a *ngIf="idInstituto=='1'" class="contact" href="mailto:mx_transparencia@greatplacetowork.com" title="mx_transparencia@greatplacetowork.com" mat-button>{{'NAV.CONTACTO.TITULO' | translate}}</a>
    <a *ngIf="idInstituto=='15'" class="contact" href="mailto:ES_info@.burgos@greatplacetowork.com" title="ES_info@greatplacetowork.com" mat-button>{{'NAV.CONTACTO.TITULO' | translate}}</a> -->

</div>
